import React, { useState } from "react";
import AlternativeCompanyCard from "./AlternativeCompanyCard";
import ImageModal from "./ImageModal";
import "./CompanyCard.css";

const CompanyCard = ({ company, searchTerm }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const openImageModal = () => {
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  return (
    <>
      <div className="company-card">
        <div className="company-header" onClick={toggleExpanded}>
          <div className="company-info">
            <img
              src={company.image}
              alt={company.name}
              className="company-image clickable"
              onClick={(e) => {
                e.stopPropagation();
                openImageModal();
              }}
              onError={(e) => {
                e.target.src =
                  "https://via.placeholder.com/400x300?text=Company+Image";
              }}
            />
            <div className="company-details">
              <h2 className="company-name">{company.name}</h2>
              {company.description && (
                <p className="company-description">{company.description}</p>
              )}
              {company.source && (
                <div className="company-source">
                  <span className="source-label">ប្រភព:</span>
                  <a
                    href={company.source}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="source-link"
                  >
                    {company.source_label}
                  </a>
                </div>
              )}
              <div className="company-stats">
                {company.alternativeCompanies &&
                  company.alternativeCompanies.length > 0 && (
                    <span>
                      {company.alternativeCompanies.length} ជម្រើសផ្សេងទៅវិញ
                    </span>
                  )}
              </div>
            </div>
          </div>
          <button className="expand-button">{isExpanded ? "−" : "+"}</button>
        </div>

        {isExpanded && (
          <div className="company-content">
            {/* Alternative Companies Section */}
            <section className="alternatives-section">
              <h3>ក្រុមហ៊ុនជម្រើសផ្សេងទៅវិញ</h3>
              <div className="alternatives-grid">
                {company.alternativeCompanies &&
                  company.alternativeCompanies.map((altCompany) => (
                    <AlternativeCompanyCard
                      key={altCompany.id}
                      company={altCompany}
                      searchTerm={searchTerm}
                    />
                  ))}
              </div>
            </section>
          </div>
        )}
      </div>

      {/* Image Modal */}
      <ImageModal
        isOpen={isImageModalOpen}
        image={company.image}
        title={company.name}
        onClose={closeImageModal}
      />
    </>
  );
};

export default CompanyCard;
